import { AbstractControl, ValidatorFn } from '@angular/forms';

export const DOMAIN_REGEX = /\b((?=[a-z0-9-]{1,63}\.)(xn--)?[a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,63}\b/;

export function domainValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const matches = DOMAIN_REGEX.test(control.value);
    return matches || !control.value ? null : { domain: true };
  };
}
